import styled from 'styled-components';

export const WarningContainer = styled.span`
  display: flex;
  align-items: center;

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.warning.main};
`;
